(function () {
    // Вида hh.ru или hh.ru.ts114.pyn.ru
    const hostname = location.hostname;
    const topLevelDomain = window.globalVars?.topLevelDomain;
    let domainString = '';
    if (topLevelDomain) {
        domainString = `domain=.${hostname.slice(hostname.indexOf(topLevelDomain))};`;
    }

    document.cookie = `GMT=${-1 * (new Date().getTimezoneOffset() / 60)};${domainString}path=/`;
})();
